module.exports = __webpack_public_path__ + "static/media/walkthrough.a66170af.svg";